let engineSingleton = null;
export function setSyncEngine(engine) {
    engineSingleton = engine;
}
export function getSyncEngine() {
    return engineSingleton;
}
